import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const CountryDropdown = (props: DropdownWithoutOptionsProps<server.dto.Country, server.dto.Countries>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={serverReference.countries}
    getLabel={c => c.name}
    getValue={c => c.key}
    value={props.value}
    onChange={props.onChange}
    config={{
      isSearchable: true,
      ...props.config
    }}
  />;
};

export default CountryDropdown;